
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'AutoApprovalSuccessMessage'
})
export default class AutoApprovalSuccessMessage extends Vue {
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String, required: true })
  message!: string;

  @Prop({ type: Array, default: () => [] })
  details!: string[];

  @Prop({ type: Boolean, default: true })
  closable!: boolean;

  @Prop({ type: Number, default: 0 })
  autoCloseDelay!: number;

  private showDetails = false;
  private autoCloseTimer: number | null = null;

  @Watch('visible')
  onVisibleChange(newVal: boolean) {
    if (newVal && this.autoCloseDelay > 0) {
      this.startAutoClose();
    } else if (!newVal) {
      this.clearAutoClose();
    }
  }

  private startAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimer = window.setTimeout(() => {
      this.onClose();
    }, this.autoCloseDelay);
  }

  private clearAutoClose() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  private onClose() {
    this.clearAutoClose();
    this.showDetails = false;
    this.$emit('close');
  }

  beforeDestroy() {
    this.clearAutoClose();
  }
}
